import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n\n  .book-info-wrapper {\n    width: 224px;\n    flex-direction: column;\n    gap: 8px;\n\n    img {\n      width: 92px;\n    }\n\n    .thumb-wrapper {\n      display: flex;\n      box-sizing: border-box;\n      flex-direction: column;\n      width: 100%;\n      padding: 8px;\n      height: 224px;\n      padding-bottom: 40px;\n    }\n\n    > div {\n      position: relative;\n    }\n\n    .preview-btn {\n      bottom: 8px;\n      left: 8px;\n      right: 8px;\n      width: auto;\n      text-align: center;\n    }\n  }\n\n  .swiper-slide {\n    width: unset;\n    height: unset;\n  }\n\n  @media (max-width: 1200px) {\n    margin-right: -32px;\n  }\n  @media (max-width: 768px) {\n    .swiper {\n      margin-right: -16px;\n    }\n\n    .book-info-wrapper {\n      width: 150px;\n\n      .thumb-wrapper {\n        height: 150px;\n        padding-bottom: 8px;\n\n        img {\n          width: 68px;\n        }\n      }\n    }\n\n    .preview-btn {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin-bottom: 20px;\n\n  span {\n    margin-left: 8px;\n    color: ",
        ";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n  }\n\n  @media (max-width: 768px) {\n    font-size: 20px;\n    span {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { BookCard } from "./BookCard";
import { ManualCurationSkeleton } from "./MainPageSkeletons";
import { SwiperCustomButton } from "./SwiperCustomButton";
export const ManualCurationSection = (param)=>{
    let { data , showSkeleton , onClick  } = param;
    const [skeletonTimer, setSkeletonTimer] = useState(false);
    const swiperRef = useRef(null);
    useEffect(()=>{
        if (showSkeleton) {
            setSkeletonTimer(true);
            setTimeout(()=>{
                setSkeletonTimer(false);
            }, 1000);
        }
    }, [
        showSkeleton
    ]);
    if (skeletonTimer) {
        return /*#__PURE__*/ _jsx(ManualCurationSkeleton, {});
    }
    if (!data) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(ManualCurationSectionWrapper, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ _jsx(SectionTitle, {
                            children: data.title
                        }),
                        /*#__PURE__*/ _jsx(SwiperCustomButton, {
                            nextClassName: "manual-curation-button-next-".concat(data.id),
                            prevClassName: "manual-curation-button-prev-".concat(data.id)
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Swiper, {
                    ref: swiperRef,
                    height: 382,
                    // width={224}
                    scrollbar: false,
                    slidesPerView: "auto",
                    spaceBetween: 20,
                    navigation: {
                        nextEl: ".manual-curation-button-next-".concat(data.id),
                        prevEl: ".manual-curation-button-prev-".concat(data.id)
                    },
                    children: data.items.map((book, index)=>{
                        return /*#__PURE__*/ _jsx(SwiperSlide, {
                            onClick: ()=>onClick(book, data.title),
                            children: /*#__PURE__*/ _jsx(BookCard, {
                                book: book,
                                index: index,
                                positionType: "curation"
                            }, "manual-curation-book-info-".concat(index))
                        }, "item-".concat(index));
                    })
                })
            ]
        }, "manual-curation-".concat(data.title))
    });
};
export const ManualCurationSectionWrapper = styled.section.withConfig({
    componentId: "sc-46385d2c-0"
})(_templateObject());
export const SectionTitle = styled.h3.withConfig({
    componentId: "sc-46385d2c-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_800, (props)=>props.theme.new.colors.sol_gray_500);
